"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var layout_components_1 = require("../layout-components");

exports.TriggerTextContainer = styled_components_1.default(layout_components_1.RowCentered)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-right: 16px;\n"], ["\n    margin-right: 16px;\n"])));
var templateObject_1;